import { useNextRouterPathsForFeatureFlags } from '#core/composables/createNextFeaturePlugin'

// see feature-flags.md
export default defineNuxtPlugin({
  async setup() {
    // process these in sync to avoid route conflicts
    await useNextRouterPathsForFeatureFlags({
      featureFlag: 'mmm-next',
      paths: ['market-maker-monitoring'],
    })
    await useNextRouterPathsForFeatureFlags({
      featureFlag: 'token-designer-v2',
      paths: [
        'share',
        'token-designer',
        'token-unlocks',
        'tokenomics',
      ],
    })
  },
})
